import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { ToastContainer } from './ToastContainer';
export const SuccessToast = (props) => {
    return (_jsxs(ToastContainer, { children: [_jsx(CheckCircleIcon, {}), _jsx("div", { children: props.message })] }));
};
